<template>
  <div class="bg-white" id="container">
    <div class="lg:container pt-5">
      <!-- <div class=" md:bg-green-500 lg:bg-blue-500">Test</div> -->
      <location :isEditButton="true" :isBorder="true" />

      <div class="flex flex-col md:flex-row mt-4">
        <!-- Filter  -->
        <div class="md:w-1/3 p-2 hidden md:flex">
          <filteprComp @fetchApi="getRate()" class="w-full"></filteprComp>
        </div>
        <!-- filter button and sort for mobile only  -->
        <div class="flex justify-around md:hidden shadow">
          <div
            class="flex items-center duration-500 px-12 cursor-pointer hover:shadow-md hover:bg-gray-50 transition ease-in-out">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" data-rtl-flip="true">
              <path
                d="M10.28 15.22a.75.75 0 0 1 0 1.06l-4.5 4.5a.8.8 0 0 1-.24.16.73.73 0 0 1-.58 0 .8.8 0 0 1-.24-.16l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V3.75a.75.75 0 0 1 1.5 0v14.69l3.22-3.22a.75.75 0 0 1 1.06 0m13.5-7.5-4.5-4.5a.8.8 0 0 0-.28-.16.73.73 0 0 0-.58 0 .8.8 0 0 0-.24.16l-4.5 4.5a.75.75 0 1 0 1.06 1.06L18 5.56v14.69a.75.75 0 0 0 1.5 0V5.56l3.22 3.22a.75.75 0 0 0 1.06 0 .75.75 0 0 0 0-1.06">
              </path>
            </svg>
            <span class="p-2">Sort</span>
          </div>

          <div class="flex items-center duration-500 px-12 cursor-pointer hover:shadow-md hover:bg-gray-50">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" data-rtl-flip="true">
              <path
                d="M.75 4.5h16.34a3.5 3.5 0 1 0 0-1.5H.75a.75.75 0 0 0 0 1.5M20.5 1.75a2 2 0 1 1-2 2 2 2 0 0 1 2-2m2.75 17.75H9.46a3.5 3.5 0 0 0-6.83 0H.75a.75.75 0 0 0 0 1.5h1.88a3.5 3.5 0 0 0 6.83 0h13.79a.75.75 0 0 0 0-1.5m-17.2 2.75a2 2 0 1 1 2-2 2 2 0 0 1-2 2M23.25 11h-7.84a3.49 3.49 0 0 0-6.82 0H.75a.75.75 0 0 0 0 1.5h7.84a3.49 3.49 0 0 0 6.82 0h7.84a.75.75 0 0 0 0-1.5M12 13.75a2 2 0 1 1 2-2 2 2 0 0 1-2 2">
              </path>
            </svg>
            <span class="p-2">Filter</span>
          </div>
        </div>
        <!-- Cars List  -->
        <div class="md:w-2/3 p-3">
          <template v-for="(value, id) in $store.state.main.vehicleGroup"
            :style="{ 'animation-delay': `${index * 0.5}s` }" class="duration-800">
            <cardCarDetails :item="value" showButtonAndPrice="true" :key="id" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { alertMixin } from "@/mixin/alertMixin";
import { axiosMixin } from "@/mixin/axiosMixin";
import { helperMixin } from "@/mixin/helperMixin";

import filteprComp from "./filter.vue";
import location from "@/components/hawk/location.vue";
import cardCarDetails from "@/components/hawk/cardCarDetails.vue";

export default {
  mixins: [alertMixin, axiosMixin, helperMixin],

  data() {
    return {
      vehicleGroup: this.$store.state.main.vehicleGroup,
      value: "",
      priceFor3Days: "Price for 1 days:",
    };
  },
  components: { filteprComp, location, cardCarDetails },
  computed: {},
  methods: {
    startLoading() {
      this.$vs.loading({
        container: "#container",
        scale: 0.6,
      });
    },
    stopLoading() {
      this.$vs.loading.close("#container > .con-vs-loading");
    },
    getRate() {
      this.startLoading();

      const { formData, filter } = this.$store.state.main.bookingDetails;

      //join formData and filter into one object
      const combinedData = {
        ...formData,
        ...filter
      };



      this.aronPost("getRate", combinedData, "", "")
        .then((response) => {
          if (response.status) {
            this.$store.state.main.vehicleGroup = response.data.rate;

            this.$store.state.main.availableCarCategories = response.data.availableCategory;

          } else {
            this.errorAlert("Error", response.data.error);
          }
          this.isReady = true;
          this.stopLoading();
        })
        .catch((error) => {
          console.log("errorsss:", error);
          this.stopLoading();
          this.isReady = true;
        });
    },
    //forward back to booking when there is no data in the store
    checkIfDataAvilable() {
      if (Object.keys(this.vehicleGroup).length === 0) {
        this.$router.push("/booking");
      }
    },
  },
  mounted() {
    this.checkIfDataAvilable();
  },
};
</script>
